
import { GameData } from "../gamestate/gameData";
import { GameTile } from "./GameTile";
// import { displayFireAroundDragonSymbol, hideDisplayFireAroundDragonSymbol, displayBonusIconDragonSymbol } from "../inGameFunction";


//Single column
export class GameColumn {


	private cardSizeX: number;
	private cardSizeY: number;//diceTexList[0].height;
	private dynamicSpeed: boolean;
	private spinCycle: number; //total cycles 
	private infiniteSpinTween: PIXI.Container;
	private copyIndex: number;
	private endArray: Array<number>;
	private startTween2: PIXI.tween.Tween;
	private maxVisibleCol: number;
	private columnIndex: number;
	private posX: number;
	private posY: number;
	private containerBG: PIXI.Container;
	private moveYPixel: number;//private cardSizeX/5;//-----------------------------SPEED in pixel per tick
	private speed: number;
	private offsetColAnimations: number;
	private stop: boolean;
	private swapSpecialSymbolsrate: number;
	private clear: boolean;
	private spinningblur: boolean;
	// private dragonSoundPlayed: Array<boolean>;
	private skip: boolean;
	private activeGameData: GameData;
	// private bonusGameFlame: boolean;//used for dragon frame is visible or not	;
	private animeCycle: number;
	private endCycle: number; //*3; //change the number of spin before stop =>result on offset stop
	private startTween: PIXI.tween.Tween;
	private tileSprite: Array<GameTile>;//Sprite  
	private maxVisibleRow: number;
	private container: PIXI.Container;
	private endTween: PIXI.tween.Tween;

	private easeInClear: boolean;

	private bonusSymbolIndex:number=9;
	//-

	private enablesuspense: boolean = true;
	private suspenseDrumRollplayed:boolean=false;

	constructor(index: number, parent: PIXI.Container, maxVisibleRow: number, maxVisibleCol: number, activeGameData: GameData) {

		this.dynamicSpeed = true;
		this.activeGameData = activeGameData;
		this.cardSizeX = this.activeGameData.cardsize// ;diceTexList[0].width;
		this.cardSizeY = this.activeGameData.cardsize//diceTexList[0].height;
		this.maxVisibleRow = maxVisibleRow;
		this.maxVisibleCol = maxVisibleCol;
		this.columnIndex = index;
		this.tileSprite = [];//Sprite    
		this.posX = 266*index// this.cardSizeX * index;
		this.posY = 0;
		this.container = new PIXI.Container();
		this.containerBG = new PIXI.Container();
		this.moveYPixel = 3//this.cardSizeX/5;//-----------------------------SPEED in pixel per tick
		this.speed = 0;
		this.animeCycle = 0;
		this.spinCycle = 8//10;
		this.offsetColAnimations = this.columnIndex * 3;
		this.endCycle = 12 + this.offsetColAnimations //*3; //change the number of spin before stop =>result on offset stop
		if (this.dynamicSpeed) {
			this.endCycle = this.spinCycle + this.offsetColAnimations
		}

		this.stop = false;
		this.swapSpecialSymbolsrate = 0;
		//used for slowdownanimation
		this.skip = false;
		this.clear = false;
		this.spinningblur = false;

		this.startTween;
		this.startTween2;
		this.endTween;
		this.endArray;
		this.easeInClear = false;
		this.infiniteSpinTween;
		this.copyIndex = maxVisibleRow - 1;
		parent.addChild(this.containerBG);
		parent.addChild(this.container);
		// this.bonusGameFlame = false;
		this.createSprite();

		// this.dragonSoundPlayed = [false, false, false]

		

	}

		public setVisible=(bool:boolean):void=>
	{	
		let newAlpha= bool?1:0;
		this.container.alpha=newAlpha;
	}
	public	clearBonusBackgroundSymbol=():void=>
	{
			for (let i = 0; i < this.tileSprite.length; i++) {
				this.tileSprite[i].clearBonusBG()				
			}
	}

	public swapSymbolPresent=(isPresent:boolean):void=>
	{
			for (let i = 0; i < this.tileSprite.length; i++) {
				this.tileSprite[i].setSymbolPresent(isPresent)				
			}
	}
	private createSprite=():void=> {


		for (var i = 0; i < this.maxVisibleRow + 2; i++) {
			this.tileSprite[i] = new GameTile(this.container, this.activeGameData);
			// this.tileSprite[i].parentContainer.scale.set(.75);//change size of dice but the gap remains same
			// this.tileSprite[i].parentContainer.x=this.posX;
			this.posY = (i % (this.maxVisibleRow + 2)) * this.cardSizeY;
			// this.tileSprite[i].parentContainer.y=this.posY;

			this.tileSprite[i].setContainerPosition(this.posX, this.posY);
			// this.tileSprite[i].gotoLoop(this.tileSprite[i].activeIndex);
			this.tileSprite[i].setCurrentFrame(this.tileSprite[i].getActiveIndex());


		}

		this.createTweens();
		// console.log(this.endCycle) 


	}
	private textureSwap=():void=> {

		// console.log("TS");
		let randGen;
	
		for (var i = this.tileSprite.length - 1; i > 0; i--) {
			// this.tileSprite[i].enableBonusIcon(false);

			let indexOfDicePerTile = this.tileSprite[i - 1].getActiveIndex();
			this.tileSprite[i].setCurrentFrame(indexOfDicePerTile)
			if (this.spinningblur && this.skip == false) {
				this.tileSprite[i].setCurrentFrameBlurred(indexOfDicePerTile)//texture=this.tileSprite[i-1].texture;
				// this.tileSprite[i].setCurrentFrame( indexOfDicePerTile);
			}
	
		}
		//start animating last cycle

		if (this.animeCycle > this.endCycle - this.maxVisibleRow - 3)//startCoping 
		{
			if (this.copyIndex >= 0) {
				this.tileSprite[0].setCurrentFrame(this.endArray[this.copyIndex]);
				this.copyIndex--;
			}
		}
		else {



				if (this.swapSpecialSymbolsrate > 3) {
					// this.tileSprite[0].setCurrentFrame(Math.floor(Math.random()*8));//specialdices
					if ((this.columnIndex) == 3 || (this.columnIndex) == 4|| (this.columnIndex) == 5) {
						randGen = Math.floor(Math.random() * 9);
						this.tileSprite[0].setCurrentFrame(randGen);//normalDices
					}
					else {
						randGen = Math.floor(Math.random() * 8);
						this.tileSprite[0].setCurrentFrame(randGen);//normalDices
					}

					this.swapSpecialSymbolsrate = 0;//fix the appear rate
				}
				else {
					// this.tileSprite[0].setCurrentFrame(Math.floor(Math.random()*6 ));//normalDices
					randGen = Math.floor(Math.random() * 8);
					this.tileSprite[0].setCurrentFrame(randGen);//normalDices

					this.swapSpecialSymbolsrate++;
				}
			// }

		}

	}
	public setEndArray=(finishingArray: Array<number>):void=> {
		this.endArray = finishingArray;

	}

	private easingOutTween=():void=> {

		this.clear = true;

		this.setEndDices();
		if (!this.endTween.active) {
			this.endTween.start();
			// this.activeGameData.sound.play('rollStop');
		
				this.activeGameData.sound_reelStop.stop()
		
			this.activeGameData.sound_reelStop.play('sound')
			this.suspenseDrumRollplayed=false;

			this.activeGameData.mainGame.getSuspense().clearSelected(this.columnIndex);

		    ///--check and play sound
			this.checkBonusSymbolOnEnd();
		}


	}
	private checkreel=():void=> {
		// check reel last time before easing out
		for (var i = 1; i < 4; i++) {
			if (this.tileSprite[i].getActiveIndex() != this.endArray[i - 1]) {
				this.tileSprite[i].setCurrentFrame(this.endArray[i - 1]);

			}
		}

	}

	// private startBonusFlameFX=(i: number):void=> {
	// 	this.bonusGameFlame = true;
	// 	let index = (i) + (this.columnIndex * 3);
	// 	displayFireAroundDragonSymbol(index, this.activeGameData);
	// }

	// private startBonusIconAnimation=(i: number):void=> {

	// 	let index = (i) + (this.columnIndex * 3);
		
	// 	displayBonusIconDragonSymbol(index, this.activeGameData);

	// }

	private animateVertical=():void=> {


		if (this.stop) { this.speed = 0; }


		this.container.y += this.speed;

		if (this.container.y > this.cardSizeY) {
			this.container.y = 0;
			this.textureSwap();

			if (this.activeGameData.infiniteSpin === false) {
				this.animeCycle++;
			}
			// if(this.columnIndex==0)
			// console.log(	this.animeCycle)		 

		}
	}

	private swapWithEndresult=():void=> {
		if (this.clear === false) {
			this.tileSprite[1].setCurrentFrame(this.endArray[0]);
			this.tileSprite[2].setCurrentFrame(this.endArray[1]);
			this.tileSprite[3].setCurrentFrame(this.endArray[2]);
			this.container.y = 0;
			// this.animeCycle=this.endCycle;//do last 5 cycle;			 

		}



	}

	private dynamicSwap=():void=> {
		let index = Math.abs(this.endCycle - this.animeCycle - 1);
		// console.log(index,this.endArray[index])
		this.tileSprite[0].setCurrentFrame(this.endArray[index]);
	}

	// public resetDelayLastReel=():void=>
	// {
		
	// 	// console.log(this.activeGameData.bonusGameMode, this.activeGameData.bonusGameModeStarted);
	// 	if(this.activeGameData.bonusGameMode, this.activeGameData.bonusGameModeStarted)  
	// 	{
	// 		this.endCycle = 12 + this.offsetColAnimations;
	// 	}                
	// }
	private reset=():void=> {
		this.activeGameData.mainGame.getSuspense().clearSelected(this.columnIndex);
		this.suspenseDrumRollplayed==false;
		this.activeGameData.mainGame
		.gethighlightBonusSymbol()
		.clearAll();

		this.speed = 0;
		this.container.y = 200;
		this.endTween.stop();
		this.endTween.reset();//SlowDown Effect reset
		this.animeCycle = 0;
		this.stop = false;
		this.easeInClear = false;
		this.startTween.reset();
		this.startTween2.reset();
		this.startTween.stop();
		this.startTween2.stop();
		// this.moveYPixel=this.cardSizeX/2;
		this.copyIndex = this.maxVisibleRow - 1;
		this.swapSpecialSymbolsrate = 0;
		this.skip = false;
		// this.dragonSoundPlayed = [false, false, false]
	
	
		this.endCycle = 12 + this.offsetColAnimations;

		if (this.dynamicSpeed) {
			this.endCycle = this.spinCycle + this.offsetColAnimations
		}

		// if(this.activeGameData.bonusGameMode===true)
		// {
			
		// }
		// if(this.activeGameData.replayMode)
		// {
		// 	// this.endCycle= 12 + this.offsetColAnimations;
		// 	this.animeCycle = 0;
		// 	console.log('tessst')
		// }
		// else
		// {
		// 	// this.endCycle = 12 + this.offsetColAnimations;
		// }

		// if (((this.activeGameData.GameContext())).bonus && ((this.activeGameData.GameContext())).gameRoundBalance.bonusSpins > 0) {
		// 	this.tileSprite[0].setCurrentFrame(Math.floor(Math.random() * 2) + 8);
		// 	this.tileSprite[1].setCurrentFrame(Math.floor(Math.random() * 2) + 8);
		// }
		// else {

		// 	this.tileSprite[0].setCurrentFrame(Math.floor(Math.random() * 6));
		// 	this.tileSprite[1].setCurrentFrame(Math.floor(Math.random() * 6));
		// }
		this.tileSprite[0].setCurrentFrame(Math.floor(Math.random() * 6));
		this.tileSprite[1].setCurrentFrame(Math.floor(Math.random() * 6));

		this.clear = false;
		// this.setReelLength();
	}


	private setEndDices=():void=> {
		this.tileSprite[1].setCurrentFrame(this.endArray[0]);
		this.tileSprite[2].setCurrentFrame(this.endArray[1]);
		this.tileSprite[3].setCurrentFrame(this.endArray[2]);

	}

	private createTweens=():void=> {




		this.startTween = PIXI.tweenManager.createTween(this.container);
		this.startTween.from({ y: this.container.y }).to({ y: -this.cardSizeY * .2 });
		this.startTween.time = 100;//300 ease in default
		this.startTween.delay = this.columnIndex * 30;
		this.startTween.easing = PIXI.tween.Easing.linear();

		this.startTween2 = PIXI.tweenManager.createTween(this.container);
		this.startTween2.to({ y: this.container.y });
		this.startTween2.time = 75;//330 ease in defalut
		this.startTween2.easing = PIXI.tween.Easing.linear();
		this.startTween2.on('end', function (self: GameColumn) {
			self.easeInClear = true;
		}.bind(this.startTween2, this));

		this.startTween.chain(this.startTween2);


		this.endTween = PIXI.tweenManager.createTween(this.container);
		this.endTween.from({ y: this.container.y }).to({ y: this.cardSizeY });
		this.endTween.time = 350;//default 350
		if (this.dynamicSpeed) {
			this.endTween.time = 350;//default 350
		}

		// this.endTween.easing = PIXI.tween.Easing.outBack(); // default outElastic
		this.endTween.easing = PIXI.tween.Easing.outBack(); // default outElastic
		this.endTween.on('end', function (self: GameColumn) {
			if (self.columnIndex === 0) {
				// console.log("stopp")
			}

			self.setEndDices();
			// self.checkDragonSymbol();
			// console.log("sess2")
			// self.checkerBlurredTexture();
			this.stop();
		}.bind(this.endTween, this));

	}

	public setExtraSpinTweenCol = (index: number): void => {
		this.tileSprite[index].setExtraSpinTweenReset();
	}

	public getSprite = (index: number): GameTile => {
		return this.tileSprite[index];
	}

	// public setFlames(bool: boolean) {
	// 	this.bonusGameFlame = bool;
	// }

	public setFixedDicesPerCol(result: Array<number>) {
		//ignore the first two
		this.tileSprite[2].setCurrentFrame(result[0]);
		this.tileSprite[3].setCurrentFrame(result[1]);
		this.tileSprite[4].setCurrentFrame(result[2]);
	}

	// public setRandomOutFrame() {
	// 	//create  random symbols that are on next on reels
	// 	this.tileSprite[0].setCurrentFrame(Math.floor(Math.random()) + 8);
	// 	this.tileSprite[1].setCurrentFrame(Math.floor(Math.random()) + 8);
	// }
	public disableAnimation()
	{
		for (let i = 0; i < this.tileSprite.length; i++) {
			this.tileSprite[i].setAnimationLoopActive(false);
			this.tileSprite[i].setWinTweenActive(false);
		}
	}
	public getValueAtLine = (index: number): number => {
		return this.tileSprite[index].getActiveIndex();
	}
	public setAnimationOnLine(index: number, bool: boolean) {
		this.tileSprite[index].setAnimationLoopActive(bool);
	}
	public setAllDefault=():void=> {

		// this.checkDragonSymbol();
		// console.log("sess")
		this.textureSwap();
		this.reset();
		this.container.y = 0;
		// this.setFlames(false)
	}

	public getParent=():PIXI.Container=>
	{
		return this.container;
	}
	public getMaxVisibleRow=():number=>
	{
		return this.maxVisibleRow
	}
	public getEndTween=():PIXI.tween.Tween=>
	{
		return this.endTween;
	}
	public getEaseInClear=():boolean=>
	{
		return this.easeInClear;
	}
	
	// public checkDragonSymbol=():void=> {










	
	// 	for (var i = 0; i < 3; i++) {
	// 		if (this.endArray[i] === 6)//check if its dragon symbol
	// 		{	// this.tileSprite[i].enableBonusIcon(true);
	// 			if (this.columnIndex === 0) {
	// 				this.startBonusFlameFX(i);
	// 				if (this.dragonSoundPlayed[0] === false) {
	// 					// this.activeGameData.soundGong.play('gong');
	// 					this.activeGameData.sound.play('drum');
	// 					this.dragonSoundPlayed[0] = true;
	// 					// console.log("GONG")
	// 				}


	// 			}

	// 			else if (this.activeGameData.mainGame.getColumn(0).bonusGameFlame) {
	// 				if (this.columnIndex === 2) {
	// 					this.startBonusFlameFX(i);
	// 					this.activeGameData.mainGame.setLastReelFire(true); //..dragonHighlighter.setReelOnFire(true)

	// 					if (this.skip === false && this.activeGameData.bonusGameModeStarted==false) {
	// 						this.activeGameData.mainGame.getColumn(4).endCycle += 25;
	// 						// console.log('ADDDELAY')
	// 					}
	// 					// if (this.activeGameData.bonusGameMode && this.activeGameData.bonusGameModeStarted) {
	// 						// console.log(this.activeGameData.bonusGameMode , this.activeGameData.bonusGameModeStarted)
						
						
						

	// 					// this.activeGameData.soundGong.play('gong');
	// 					if ((this.activeGameData.GameContext()).usedInputAction === "BET" && (this.activeGameData.GameContext()).bonus) {
	// 						this.activeGameData.lastReelSuspense = true;
	// 					}
	// 					else {
	// 						this.activeGameData.lastReelSuspense = false;
	// 					}

	// 					if (this.dragonSoundPlayed[1] === false) {
	// 						this.activeGameData.sound.play('drum');
	// 						this.dragonSoundPlayed[1] = true;
	// 						// console.log("GONG")
	// 					}

	// 				}

	// 				else if (this.activeGameData.mainGame.getColumn(2).bonusGameFlame) {
	// 					if (this.columnIndex === 4) {
	// 						this.activeGameData.mainGame.setLastReelFire(false); //..dragonHighlighter.setReelOnFire(false)
	// 						this.startBonusFlameFX(i);


	// 						if (this.dragonSoundPlayed[2] === false) {
	// 							this.activeGameData.sound.play('drum');
	// 							this.dragonSoundPlayed[2] = true;
	// 							// console.log("GONG")
	// 						}
	// 						// this.activeGameData.soundGong.play('gong');
	// 						// this.activeGameData.music2.play('') 

	// 					}
	// 				}
	// 			}
	// 			this.startBonusIconAnimation(i);
	// 		}

	// 		else {
	// 			if (this.columnIndex === 2 && this.activeGameData.mainGame.getColumn(0).bonusGameFlame === false) {
	// 				this.disableBonusFlameFX();
	// 				// console.log("Disable"+this.columnIndex)
	// 			}

	// 			if (this.columnIndex === 4 && this.activeGameData.mainGame.getColumn(2).bonusGameFlame === false) {
	// 				this.disableBonusFlameFX();
	// 				this.activeGameData.mainGame.setLastReelFire(false); //.dragonHighlighter.setReelOnFire(false);
	// 				// console.log("Disable"+this.columnIndex)
	// 			}
	// 		}

	// 	}
	// 	if (this.activeGameData.skipReelOnFlameAnimation == true) {
	// 		this.activeGameData.mainGame.setLastReelFire(false)//.dragonHighlighter.setReelOnFire(false);
	// 	}
	// 	// console.log(this.tileSprite[i].activeIndex)				

	// }
	// private disableBonusFlameFX=():void=> {
	// 	// console.log("disableFlames")
	// 	this.activeGameData.mainGame.getColumn(0).bonusGameFlame = false;
	// 	this.activeGameData.mainGame.getColumn(2).bonusGameFlame = false;
	// 	this.activeGameData.mainGame.getColumn(4).bonusGameFlame = false;
	// 	hideDisplayFireAroundDragonSymbol(this.activeGameData);

	// 	// this.activeGameData.mainGame.columns[4].endCycle==13 +this.offsetColAnimations ;
	// }
	public setTweenIn() {

		// before easing out , switch with end results
		this.swapWithEndresult();
		if (!this.startTween.active) {
			this.startTween.start();
		}


	}

	public setSpeed=(dt: number):void=> {
		//when the skip isbuuton is pressed and the hasnt yet start skip
		if (this.skip === false && this.animeCycle < this.endCycle - this.columnIndex) {
			if (this.activeGameData.skipAnimation) {

				if (navigator.vibrate != undefined) {
					navigator.vibrate(0);
				}


				this.spinningblur = false;
				this.swapWithEndresult();

				//first set end timer for each column  
				// setTimeout(function()				
				// {this.animeCycle=this.endCycle;}.bind(this), 500*this.columnIndex);

				this.animeCycle = this.endCycle - this.columnIndex;//-5;
				this.moveYPixel = 12 * this.cardSizeX;

				if (this.dynamicSpeed) {
					this.animeCycle = this.endCycle// - this.columnIndex - 3;
					this.moveYPixel = 40 * this.cardSizeX; //skip speed-----
				}

				


				if (this.columnIndex === this.maxVisibleCol - 1) {
					this.activeGameData.skipAnimation = false;
				}
				this.skip = true;

				// console.log("skipGame");

				this.activeGameData.skipReelOnFlameAnimation = true;
			}
			else {

				if (this.activeGameData.lastReelSuspense && this.columnIndex == 4) {

					if (this.dynamicSpeed) {
						this.moveYPixel = 18 * this.cardSizeX; //Normal  speed
						if (navigator.vibrate != undefined) { navigator.vibrate([500, 250, 500, 250]); }


					}
				}

				else {
					this.moveYPixel = 12 * this.cardSizeX; //Normal  speed
					if (this.dynamicSpeed) {
						this.moveYPixel = 14 * this.cardSizeX; //Normal  speed
					}
				}


			}
		}



		if (this.animeCycle >= this.endCycle) {
			this.speed = 0;
			this.spinningblur = false;
			if (this.stop === false) {
				this.stop = true;

				this.checkreel()
				this.easingOutTween();//call ending animation

			}
		}

		else {
      //suspense SPIN check
	  if(this.activeGameData.commonConfigData.nearMissAllowed)
	  {
		this.checkSuspenseCondition();
	  }
 

			this.speed = (this.moveYPixel) / (1000 / dt);
			// console.log(this.speed)
			// this.speed = 50;//(this.moveYPixel*60) /(1000/dt);
			if (this.animeCycle >= this.endCycle - 3) {
				this.spinningblur = false;
				this.dynamicSwap()
			}
			else {
				this.spinningblur = true;
			}

			this.animateVertical();
		}






	}


	private checkSuspenseCondition=():void=>
	{
	  //suspense SPIN
	  if (
		this.enablesuspense &&
		this.columnIndex >= 2 &&
		this.activeGameData.mainGame.getColumn(this.columnIndex - 1).endTween
		  .isStarted
	  ) {
		this.checkSuspenseBonusSymbolCount();
	  }
	}
	

	private checkSuspenseBonusSymbolCount = (): void => {

		//suspense buildup
	
		let totalBonusSymbolCount = 0;
	
		if (this.columnIndex >= 2) {
		//   console.log(this.activeGameData.mainGame.getColumn(0).endArray);
		  for (let i = 0; i < this.columnIndex; i++) {
			if (
			  this.activeGameData.mainGame.getColumn(i).endArray[0] ==
			  this.bonusSymbolIndex
			) {
			  totalBonusSymbolCount++;
			}
			if (
			  this.activeGameData.mainGame.getColumn(i).endArray[1] ==
			  this.bonusSymbolIndex
			) {
			  totalBonusSymbolCount++;
			}
			if (
			  this.activeGameData.mainGame.getColumn(i).endArray[2] ==
			  this.bonusSymbolIndex
			) {
			  totalBonusSymbolCount++;
			}
		  }
		}
	
	  
		if (totalBonusSymbolCount >= 2) {
		  // this.moveYPixel = 40 * this.cardSizeX; //Normal  speed
		  // this.endCycle=100//50*this.columnIndex+50;
		  if(this.suspenseDrumRollplayed==false)
		  {

			this.activeGameData.sound_suspenseBuildDrum.stop();
			this.activeGameData.sound_suspenseBuildDrum.play('sound');
			this.suspenseDrumRollplayed=true;
			this.activeGameData.mainGame.getSuspense().playSelected(this.columnIndex);
		  }
		
	
		  for (
			let i = this.columnIndex;
			i < this.activeGameData.mainGame.getTotalColumns();
			i++
		  ) {
			this.activeGameData.mainGame.getColumn(i).moveYPixel =
			  40 * this.cardSizeX; //Normal  speed
			this.activeGameData.mainGame.getColumn(i).endCycle =
			  20 * this.columnIndex + 10;
		  }
		}
	  };


	  
  public checkBonusSymbolOnEnd = (): void => {
   

    let containsBonusSymbol = false;
    for (let i = 0; i < this.endArray.length; i++) {
      if (this.endArray[i] == this.bonusSymbolIndex) {
        containsBonusSymbol = true;

        this.activeGameData.mainGame
          .gethighlightBonusSymbol()
          .playSelected([this.columnIndex, i]);
      }
    }
    if (containsBonusSymbol) {
		if(this.activeGameData.sound_bonusSymbolInReel.playing)
		{
			this.activeGameData.sound_bonusSymbolInReel.stop();
		}

		
		if(this.activeGameData.totalBonusSymbolVisible<3)
		{
			this.activeGameData.totalBonusSymbolVisible++;
		}
	    this.activeGameData.sound_bonusSymbolInReel.volume((this.activeGameData.totalBonusSymbolVisible/3)/2);
	
		//sound play condition check
		let playSound=false;
		if(this.activeGameData.totalBonusSymbolVisible==1 && this.columnIndex<3)
		{
			playSound=true;
		}
		else if(this.activeGameData.totalBonusSymbolVisible==2 && this.columnIndex<4)
		{
			playSound=true;
		}
		else  if(this.activeGameData.totalBonusSymbolVisible==3 && this.columnIndex<5)
		{
			playSound=true;
		}
	


		if(playSound)
		{
			this.activeGameData.sound_bonusSymbolInReel.play("sound");
		}

		

    }
  };
	public forceStop=():void=> {
	
		this.container.y = 0;
	}

}

